module.exports = __webpack_public_path__ + "880a29044c173d0852531399a5cc6479.svg";